export const studentPricing = [
	{
		country: 'UK',
		title: 'Subscription',
		subTitle: 'Billed monthly',
		oldAmount: 120,
		currentAmount: 9.99,
		saveAmount: 0,
		period: 'mth',
		isBestValue: false,
		details: [
			{
				title: 'Cancelable anytime',
				isComingSoon: false
			},
			{
				title: '1 connected child',
				isComingSoon: false
			},
			{
				title: 'Assign tutorials & tests',
				isComingSoon: false
			},
			{
				title: 'Track & Share progress',
				isComingSoon: false
			},
			{
				title: 'View leaderboard',
				isComingSoon: false
			},
			{
				title: 'NFT wallet',
				isComingSoon: true
			}
		]
	},
	{
		country: 'UK',
		title: 'Annual',
		subTitle: 'Billed yearly',
		oldAmount: 120,
		currentAmount: 72.00,
		saveAmount: 48,
		period: 'yr',
		isBestValue: false,
		details: [
			{
				title: 'Cancelable anytime',
				isComingSoon: false
			},
			{
				title: '1 connected child',
				isComingSoon: false
			},
			{
				title: 'Assign tutorials & tests',
				isComingSoon: false
			},
			{
				title: 'Track & Share progress',
				isComingSoon: false
			},
			{
				title: 'View leaderboard',
				isComingSoon: false
			},
			{
				title: 'NFT wallet',
				isComingSoon: true
			}
		]
	},
	{
		country: 'UK',
		title: 'Installment',
		subTitle: 'Billed monthly for a year',
		oldAmount: 120,
		currentAmount: 7.99,
		saveAmount: 24,
		period: 'mth',
		isBestValue: false,
		details: [
			{
				title: 'Cancelable anytime',
				isComingSoon: false
			},
			{
				title: '1 connected child',
				isComingSoon: false
			},
			{
				title: 'Assign tutorials & tests',
				isComingSoon: false
			},
			{
				title: 'Track & Share progress',
				isComingSoon: false
			},
			{
				title: 'View leaderboard',
				isComingSoon: false
			},
			{
				title: 'NFT wallet',
				isComingSoon: true
			}
		]
	}
]

export const teacherPricing = [
	{
		country: 'NGN',
		title: 'Subscription',
		subTitle: 'From ₦3000 per student per term',
		oldAmount: 0,
		currentAmount: 3000,
		saveAmount: 0,
		period: 'term',
		isBestValue: false,
		details: [
			{
				title: 'Cancelable anytime',
				isComingSoon: false
			},
			{
				title: '1 connected child',
				isComingSoon: false
			},
			{
				title: 'Assign tutorials & tests',
				isComingSoon: false
			},
			{
				title: 'Track & Share progress',
				isComingSoon: false
			},
			{
				title: 'View leaderboard',
				isComingSoon: false
			},
			{
				title: 'NFT wallet',
				isComingSoon: true
			}
		]
	},
	{
		country: 'UK',
		title: 'Subscription',
		subTitle: '£1000 per annum',
		oldAmount: 0,
		currentAmount: 1000,
		saveAmount: 0,
		period: 'term',
		isBestValue: false,
		details: [
			{
				title: 'Cancelable anytime',
				isComingSoon: false
			},
			{
				title: '1 connected child',
				isComingSoon: false
			},
			{
				title: 'Assign tutorials & tests',
				isComingSoon: false
			},
			{
				title: 'Track & Share progress',
				isComingSoon: false
			},
			{
				title: 'View leaderboard',
				isComingSoon: false
			},
			{
				title: 'NFT wallet',
				isComingSoon: true
			}
		]
	},
	{
		country: 'NGN',
		title: 'Subscription',
		subTitle: 'Contact Us',
		oldAmount: 0,
		currentAmount: undefined,
		saveAmount: 0,
		period: 'year',
		isBestValue: false,
		details: [
			{
				title: 'Cancelable anytime',
				isComingSoon: false
			},
			{
				title: '1 connected child',
				isComingSoon: false
			},
			{
				title: 'Assign tutorials & tests',
				isComingSoon: false
			},
			{
				title: 'Track & Share progress',
				isComingSoon: false
			},
			{
				title: 'View leaderboard',
				isComingSoon: false
			},
			{
				title: 'NFT wallet',
				isComingSoon: true
			}
		]
	},
	{
		country: 'UK',
		title: 'Subscription',
		subTitle: 'Contact Us',
		oldAmount: 0,
		currentAmount: undefined,
		saveAmount: 0,
		period: 'year',
		isBestValue: false,
		details: [
			{
				title: 'Cancelable anytime',
				isComingSoon: false
			},
			{
				title: '1 connected child',
				isComingSoon: false
			},
			{
				title: 'Assign tutorials & tests',
				isComingSoon: false
			},
			{
				title: 'Track & Share progress',
				isComingSoon: false
			},
			{
				title: 'View leaderboard',
				isComingSoon: false
			},
			{
				title: 'NFT wallet',
				isComingSoon: true
			}
		]
	}
]

export const avatarConfigs: any = {
	topType: [
		'NoHair',
		'Eyepatch',
		'Hat',
		'Hijab',
		'Turban',
		'WinterHat1',
		'WinterHat2',
		'WinterHat3',
		'WinterHat4',
		'LongHairBigHair',
		'LongHairBob',
		'LongHairBun',
		'LongHairCurly',
		'LongHairCurvy',
		'LongHairDreads',
		'LongHairFrida',
		'LongHairFro',
		'LongHairFroBand',
		'LongHairNotTooLong',
		'LongHairShavedSides',
		'LongHairMiaWallace',
		'LongHairStraight',
		'LongHairStraight2',
		'LongHairStraightStrand',
		'ShortHairDreads01',
		'ShortHairDreads02'
	],
	accessoriesType: [
		'Blank',
		'Kurt',
		'Prescription01',
		'Prescription02',
		'Round',
		'Sunglasses',
		'Wayfarers'
	],
	hatColor: [
		'Black',
		'Blue01',
		'Blue02',
		'Blue03',
		'Gray01',
		'Gray02',
		'Heather',
		'PastelBlue',
		'PastelGreen',
		'PastelOrange',
		'PastelRed',
		'PastelYellow',
		'Pink',
		'Red',
		'White'
	],
	hairColor: [
		'Auburn',
		'Black',
		'Blonde',
		'BlondeGolden',
		'Brown',
		'BrownDark',
		'PastelPink',
		'Platinum',
		'Red',
		'SilverGray'
	],
	facialHairType: [
		'Blank',
		'BeardMedium',
		'BeardLight',
		'BeardMajestic',
		'MoustacheFancy',
		'MoustacheMagnum'
	],
	facialHairColor: [
		'Auburn',
		'Black',
		'Blonde',
		'BlondeGolden',
		'Brown',
		'BrownDark',
		'Platinum',
		'Red'
	],
	clotheType: [
		'BlazerShirt',
		'BlazerSweater',
		'CollarSweater',
		'GraphicShirt',
		'Hoodie',
		'Overall',
		'ShirtCrewNeck',
		'ShirtScoopNeck',
		'ShirtVNeck'
	],
	clotheColor: [
		'Black',
		'Blue01',
		'Blue02',
		'Blue03',
		'Gray01',
		'Gray02',
		'Heather',
		'PastelBlue',
		'PastelGreen',
		'PastelOrange',
		'PastelRed',
		'PastelYellow',
		'Pink',
		'Red',
		'White'
	],
	graphicType: [
		'Bat',
		'Cumbia',
		'Deer',
		'Diamond',
		'Hola',
		'Pizza',
		'Resist',
		'Selena',
		'Bear',
		'SkullOutline',
		'Skull'
	],
	eyeType: [
		'Close',
		'Cry',
		'Default',
		'Dizzy',
		'EyeRoll',
		'Happy',
		'Hearts',
		'Side',
		'Squint',
		'Surprised',
		'Wink',
		'WinkWacky'
	],
	eyebrowType: [
		'Angry',
		'AngryNatural',
		'Default',
		'DefaultNatural',
		'FlatNatural',
		'RaisedExcited',
		'RaisedExcitedNatural',
		'SadConcerned',
		'SadConcernedNatural',
		'UnibrowNatural',
		'UpDown',
		'UpDownNatural'
	],
	mouthType: [
		'Concerned',
		'Default',
		'Disbelief',
		'Eating',
		'Grimace',
		'Sad',
		'ScreamOpen',
		'Serious',
		'Smile',
		'Tongue',
		'Twinkle',
		'Vomit'
	],
	skinColor: [
		'Tanned',
		'Yellow',
		'Pale',
		'Light',
		'Brown',
		'DarkBrown',
		'Black'
	]
}

export const avataaarsURL = `https://avataaars.io/?`

